module.exports = __webpack_public_path__ + "img/cake.b93062bf.jpg";